import { render, staticRenderFns } from "./GetData.vue?vue&type=template&id=78305735"
import script from "./GetData.vue?vue&type=script&lang=js"
export * from "./GetData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports